import{a as e}from"./chunk-SNYM3WT2.js";import{m as o}from"./chunk-HBP5N4FR.js";o();var I=()=>{let{isLoggedIn:n}=e();return n};export{I as a};
//# sourceMappingURL=chunk-A4EE4RJE.js.map
